<template>
    <div class="test-run-index">
        <div>
            <b-loading is-full-page :active="isLoading"></b-loading>
            <b-notification v-if="error" type="is-danger is-light" aria-close-label="Close notification" role="alert">{{ error }}</b-notification>
                <div class="card">
                    <div class="card-content">
                        <div class="columns is-tablet">
                            <div class="column">
                                <b-field label="Products">
                                    <b-taginput
                                        v-model="selectedProducts"
                                        :data="filteredProducts"
                                        autocomplete
                                        open-on-focus
                                        icon="label"
                                        field="name"
                                        placeholder="Add a product"
                                        @typing="queries.product = $event">
                                    </b-taginput>
                                </b-field>
                                <b-field label="Platforms">
                                    <b-taginput
                                        v-model="selectedPlatforms"
                                        :data="filteredPlatforms"
                                        autocomplete
                                        open-on-focus
                                        icon="label"
                                        field="name"
                                        placeholder="Add a platform"
                                        @typing="queries.platform = $event">
                                    </b-taginput>
                                </b-field>
                                <b-field label="Branch">
                                    <b-taginput
                                        v-model="selectedBranches"
                                        :data="filteredBranches"
                                        autocomplete
                                        open-on-focus
                                        icon="label"
                                        field="name"
                                        placeholder="Add a branch"
                                        @typing="queries.branch = $event">
                                    </b-taginput>
                                </b-field>
                                <b-field label="Target (regexp)">
                                    <b-input
                                        v-model="filters.target_name"
                                        :disabled="filters.only_last_commits"/>
                                </b-field>
                            </div>
                            <div class="column">
                                <b-field label="CI service">
                                    <b-taginput
                                        v-model="selectedCIServices"
                                        :data="filteredCIServices"
                                        autocomplete
                                        open-on-focus
                                        icon="label"
                                        field="name"
                                        placeholder="Add a CI service"
                                        @typing="queries.ciService = $event">
                                    </b-taginput>
                                </b-field>
                                <b-field label="Build trigger">
                                    <b-taginput
                                        v-model="selectedBuildTypes"
                                        :data="filteredBuildTypes"
                                        autocomplete
                                        open-on-focus
                                        icon="label"
                                        field="name"
                                        placeholder="Add a build trigger"
                                        @typing="queries.buildType = $event">
                                    </b-taginput>
                                </b-field>
                                <b-tag v-if="filters.excluded_target_build_ids.length > 0"
                                         type="is-primary"
                                         closable
                                         aria-close-label="Clear"
                                         @close="clearExcludedTargetBuilds">
                                    {{ filters.excluded_target_build_ids.length }} excluded target builds
                                </b-tag>
                                <b-field label="Time interval">
                                    <div class="field">
                                        <b-select expanded v-model="filters.time_interval"
                                                  :disabled="filters.only_last_commits">
                                            <option
                                                v-for="option in TIME_INTERVAL_OPTIONS"
                                                :value="option.value.toString()"
                                                :key="option.value">
                                                {{ option.title }}
                                            </option>
                                        </b-select>
                                        <b-datepicker
                                            :disabled="filters.only_last_commits"
                                            v-if="filters.time_interval === '-2'"
                                            placeholder="Click to select..."
                                            v-model="filters.dates"
                                            icon="calendar-today"
                                            range>
                                        </b-datepicker>
                                    </div>
                                </b-field>
                                <b-field label="Commit id">
                                    <b-input v-model="filters.commit_id"/>
                                </b-field>
                                <b-checkbox v-model="filters.only_last_commits">
                                    Latest commits only
                                </b-checkbox>
                            </div>
                        </div>
                        <b-button type="is-primary" @click="onSearchClick">Search</b-button>
                    </div>
                </div>
            <br>

            <template v-if="dataIsLoaded">
                <div class="level">
                    <p>
                        Found <b>{{ testRunsTargetBuildsTotalCount }} target builds</b>
                        ({{ Math.ceil(testRunsTargetBuildsTotalCount/PER_PAGE) }} pages)
                    </p>
                    <UploadRequestResultsAnnotation></UploadRequestResultsAnnotation>
                </div>
            </template>
        </div>

        <div>
            <br>
            <b-pagination
                id="tablePagination"
                v-if="dataIsLoaded"
                style="width: 20vw;"
                :total="testRunsTargetBuildsTotalCount"
                :current="currentPage"
                size="is-small"
                v-on:change="onChangePage"
                :per-page="PER_PAGE"
                order="is-centered"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page">
            </b-pagination>
            <UploadRequestResultsTable
                :upload-dates="uploadDatesPage"
                :upload-requests="uploadRequests"
                :target-builds="testRunsTargetBuilds"
                v-on:select-upload-request-results="onSelectUploadRequestResults"
                @delete-target-build="excludeTargetBuild"
                :key="rowsCurrentPage"
                v-if="true">
                <template #empty-message>
                    <span v-if="!dataIsLoaded">
                        Set filters and click "Search"!
                    </span>
                    <span v-else>
                        No results found
                    </span>
                </template>
            </UploadRequestResultsTable>
            <div class="container" style="margin-bottom: 1vh" v-if="dataIsLoaded && !isLoading">
                <div class="level">
                    <b-button active style="width: 25vw" icon-left="arrow-up" :disabled="rowsCurrentPage <= 1" @click="prevDatesPage">
                        Show previous test dates page{{ this.rowsCurrentPage <= 1 ? "" : ": " + (this.rowsCurrentPage - 1) }}
                    </b-button>
                    <p>
                        <b> Current test dates page: {{ this.rowsCurrentPage }} / {{ this.totalDatesPages }} </b>
                    </p>
                    <b-button active style="width: 25vw" icon-left="arrow-down" :disabled="rowsCurrentPage >= totalDatesPages" @click="nextDatesPage">
                        Show next test dates page{{ this.rowsCurrentPage >= this.totalDatesPages ? "" : ": " + (this.rowsCurrentPage + 1) }}
                    </b-button>
                </div>
            </div>
        </div>

        <b-modal :active="currentUploadRequestResultsDetails != null"
                 full-screen has-modal-card :can-cancel="false">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">XML upload request results</p>
                    <button class="delete" aria-label="close" @click="onCloseUploadRequestResultsDetails()"></button>
                </header>
                <div class="modal-card-body">
                    <UploadRequestResultsDetails v-if="currentUploadRequestResultsDetails"
                                          :target-build-id="currentUploadRequestResultsDetails.targetBuildId"
                                          :requests-date="currentUploadRequestResultsDetails.requestsDate"/>
                </div>

            </div>
        </b-modal>
    </div>

</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {
    CI_SERVICES,
    UPLOAD_REQUEST_RESULTS_TARGET_BUILDS_PER_PAGE,
    UPLOAD_REQUEST_RESULTS_DATES_PER_PAGE, TIME_INTERVAL_OPTIONS,
} from "../utils/constants";
import {formatDate, valueToArray} from "../utils/helpers";
import filtersMixin from "../utils/filtersMixin";
import UploadRequestResultsTable from "@/components/UploadRequestResultsTable.vue";
import UploadRequestResultsAnnotation from "@/components/UploadRequestResultsAnnotation.vue";
import UploadRequestResultsDetails from "@/views/UploadRequestResultsDetails.vue";

export default {
    name: "UploadRequestResultsIndex",
    mixins: [filtersMixin],
    data() {
        return {
            isLoading: false,
            error: null,
            filters: {},
            PER_PAGE: UPLOAD_REQUEST_RESULTS_TARGET_BUILDS_PER_PAGE,
            DATES_PER_PAGE: UPLOAD_REQUEST_RESULTS_DATES_PER_PAGE,
            CI_SERVICES,
            TIME_INTERVAL_OPTIONS,
            showTargetBuildDetails: false,
            dataIsLoaded: false,

            queries: {
                product: '',
                platform: '',
                branch: '',
                target_name: '',
                ciService: '',
                buildType: '',
            },
        }
    },
    computed: {
        ...mapGetters('TargetBuilds', [
            'targetBuilds',
            'testRunsTargetBuilds',
            'testRunsTargetBuildsTotalCount',
        ]),
        ...mapGetters('Auth', [
            'hasAccess',
        ]),
        ...mapGetters('UploadRequests', [
            'uploadRequests',
            'requestDates',
        ]),
        currentUploadRequestResultsDetails() {
            const targetBuildId = this.$route.query.currentTargetBuildId;
            const requestsDate = this.$route.query.currentRequestsDate;
            if (targetBuildId == null || requestsDate == null) return null;
            return { targetBuildId, requestsDate };
        },
        currentPage() {
            return parseInt(this.$route.query.page || 1);
        },
        rowsCurrentPage() {
            return parseInt(this.$route.query.rowsPage || 1);
        },
        totalDatesPages() {
            return Math.ceil(this.uploadRequests.length / this.DATES_PER_PAGE)
        },
        uploadDatesPage() {
            return this.requestDates.slice(
                (this.rowsCurrentPage - 1) * this.DATES_PER_PAGE,
                this.rowsCurrentPage * this.DATES_PER_PAGE
            )
        },
    },
    methods: {
        ...mapActions('Platforms', [
            'fetchPlatforms',
        ]),
        ...mapActions('TargetBuilds', [
            'fetchBranches',
            'fetchProducts',
            'fetchBuildTypes',
            'fetchCIServices',
            'fetchByName',
        ]),
        ...mapActions('UploadRequests', [
            'fetchUploadRequests',
        ]),
        ...mapMutations('TargetBuilds', [
            'CLEAR_TEST_RUNS_TARGET_BUILDS',
        ]),
        ...mapMutations('UploadRequests', [
            'CLEAR_UPLOAD_REQUESTS',
            'CLEAR_REQUEST_DATES',
        ]),
        setFiltersByQuery(query) {
            this.filters = {
                platform_ids: valueToArray(query.platform_ids),
                branch_ids: valueToArray(query.branch_ids),
                test_suite_name_ids: valueToArray(query.test_suite_name_ids),
                product_ids: query.product_ids == null ? ["2"] : valueToArray(query.product_ids),
                show_skipped_results: query.show_skipped_results === 'true',
                only_last_commits: query.only_last_commits === 'true',
                time_interval: query.time_interval == null ? '-1' : query.time_interval,
                dates: valueToArray(query.dates).map(item => new Date(item)),
                test_name: query.test_name || '',
                commit_id: query.commit_id || '',
                target_name: query.target_name || '',
                ci_service_ids: valueToArray(query.ci_service_ids),
                build_type_ids: valueToArray(query.build_type_ids),
                excluded_target_build_ids: valueToArray(query.excluded_target_build_ids),
            }
        },
        nextDatesPage() {
            this.changeDatesPage(this.rowsCurrentPage + 1)
        },
        prevDatesPage() {
            this.changeDatesPage(this.rowsCurrentPage - 1)
        },
        fetchData() {
            return [
                this.fetchPlatforms(),
                this.fetchBranches(),
                this.fetchProducts(),
                this.fetchBuildTypes(),
                this.fetchCIServices(),
            ];
        },
        async getTargetByName() {
            const targetName = this.$route.query.detail_target_name;
            if (targetName == null) return;
            delete this.$route.query.detail_target_name;
            const targetId = await this.fetchByName(targetName);
            const query = Object.assign({}, this.$route.query, {
                currentTargetBuildDetailsId: targetId,
            });
            await this.$router.push({ name: this.$route.name, query });
        },
        async getBranchByName() {
            const branchName = this.$route.query.branches;
            if (!branchName)
                return;

            const branch = this.branches.find((branch) => branch.name === branchName);
            if (branch) {
                this.filters.branch_ids.push(`${branch.id}`);
                await this.replaceRouterField("branches", "branch_ids", `${branch.id}`)
            } else {
                return Promise.reject(`Unable to found branch ${branchName}`)
            }
        },
        async getProductByName() {
            const productName = this.$route.query.products;
            if (!productName)
                return;
    
            if (productName === "all") {
                this.filters.product_ids = [];
                await this.replaceRouterField("products")
                return;
            }

            const product = this.products.find((product) => product.name === productName);
            if (product) {
                this.filters.product_ids = [`${product.id}`];
                await this.replaceRouterField("products", "product_ids", [`${product.id}`])
            } else {
                return Promise.reject(`Unable to found product ${productName}`)
            }
        },
        async replaceRouterField(oldField, newField, value) {
            const query = Object.assign({}, this.$route.query);
            delete query[oldField];
            query[newField] = value;
            await this.$router.push({ name: this.$route.name, query });
        },
        async setFiltersByName() {
            await this.getBranchByName();
            await this.getProductByName();
            await this.getTargetByName();
        },
        async search() {
            if (!this.hasAccess) return;
            this.error = null;
            this.isLoading = true;
            try {
                const filters = Object.assign({}, this.filters, {
                    page: this.currentPage,
                    per_page: this.PER_PAGE,
                    dates: this.filters.dates.map(date => formatDate(date)),
                });
                await this.fetchUploadRequests({ filters });
                this.dataIsLoaded = true;
            } catch(message) {
                this.error = message;
            }
            this.isLoading = false;
        },
        onSelectUploadRequestResults({ requestsDate, targetBuildId }) {
            const query = Object.assign({}, this.$route.query, {
                currentRequestsDate: requestsDate,
                currentTargetBuildId: targetBuildId,
            });
            this.$router.push({ name: 'UploadRequestResultsIndex', query })
        },
        onCloseUploadRequestResultsDetails() {
            const query = this._.omit(this.$route.query, ['currentRequestsDate', 'currentTargetBuildId']);
            this.$router.push({ name: 'UploadRequestResultsIndex', query });
        },
        async onChangePage(page) {
            const query = Object.assign({}, this.$route.query, { page, rowsPage: 1 });
            await this.$router.push({ name: this.$route.name, query });
            await this.search();
            this.$scrollTo('#tablePagination');
        },
        async changeDatesPage(rowsPage) {
            const query = Object.assign({}, this.$route.query, { rowsPage });
            await this.$router.push({ name: this.$route.name, query });
        },
        clearData() {
            this.CLEAR_TEST_RUNS_TARGET_BUILDS();
            this.CLEAR_UPLOAD_REQUESTS();
            this.CLEAR_REQUEST_DATES();
        },
        clearExcludedTargetBuilds() {
            this.filters.excluded_target_build_ids = [];
            this.search();
        },
        excludeTargetBuild(id) {
            this.filters.excluded_target_build_ids.push(id);
            this.$router.replace({
                name: this.$route.name,
                query: Object.assign({}, this.$route.query,
                    {excluded_target_build_ids: this.filters.excluded_target_build_ids})
            });
            this.search()
        },
        afterSearch() {
            this.$scrollTo('#tablePagination');
        },
    },
    components: {
        UploadRequestResultsDetails,
        UploadRequestResultsAnnotation,
        UploadRequestResultsTable,
    },
}
</script>

<style lang="scss">

</style>